// TMP
export function format_price(price, symbol, currencyCode = '', isoCode = 'fr') {
    if (symbol === "$") {
        if(isoCode == 'fr') {
            return  (parseFloat(price) / 100).toFixed(2) + ' ' + symbol
        } else {
            return symbol + (parseFloat(price) / 100).toFixed(2) + ' ' + currencyCode
        }
    } else {
        return (parseFloat(price) / 100).toFixed(2) + symbol
    }
}
